import types from './peopleTypes.js'

const mutations = {
  [types.SET_ACCOUNTS](state, payload) {
    state.accounts = []
    state.accounts = payload.accounts
  },

  [types.APPEND_ACCOUNT](state, payload) {
    const currentAccounts = Object.assign([], state.accounts)

    const ids = currentAccounts.map(item => {
      return item._id
    })

    if (ids.indexOf(payload.account._id) === -1) {
      currentAccounts.unshift(payload.account)
    }

    state.accounts = currentAccounts
  },

  [types.UPDATE_ACCOUNT](state, payload) {
    const ids = state.accounts.map(item => {
      return item._id
    })

    const indexOfAccountInArray = ids.indexOf(payload.account._id)
    if (indexOfAccountInArray >= -1) {
      const account = payload.account
      state.accounts.splice(indexOfAccountInArray, 1, account)
    }
  },

  [types.SET_PROFILE](state, payload) {
    state.profile = payload.profile
  },

  [types.CLEAR_PROFILE](state) {
    state.profile = {}
  },

  [types.CLEAR_USER_REVS](state) {
    state.userRevs = []
  },

  [types.SET_USER_REVS](state, payload) {
    state.userRevs = payload.revs
  },

  [types.REMOVE_USER_FROM_LIST](state, payload) {
    const index = state.accounts.findIndex(account => {
      return account._id === payload.account._id
    })
    state.accounts.splice(index, 1)
  },

  [types.SET_REV_CREATE_ACCOUNTS](state, payload) {
    state.uberFilterAccounts = payload.accounts
  },

  [types.CLEAR_REV_CREATE_ACCOUNTS](state) {
    state.uberFilterAccounts = []
  },
}

export default mutations
